import "./Equipo.css";
import { AiOutlineTeam } from "react-icons/ai";
import { FaEnvelope, FaPhoneAlt, FaUser } from "react-icons/fa";
import React, { useMemo, useState, useEffect } from "react";
import CargandoSpinner from "../../0. Utilidades/loadingSpinner";

const EquipoModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [profesionales, setProfesionales] = useState([]);

  const equipoKpis = useMemo(() => {
    const gerenciaCount = profesionales.filter((profesional) =>
      (profesional.groups || []).some(
        (group) => group.name?.toLowerCase() === "gerencia",
      ),
    ).length;

    return [
      { title: "Integrantes", value: profesionales.length },
      { title: "Gerencia", value: gerenciaCount },
    ];
  }, [profesionales]);

  useEffect(() => {
    if (isOpen) {
      const apiUrl = `${process.env.REACT_APP_BASE_API}api/perfiles/profesionales/?equipo=true`;

      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => setProfesionales(data))
        .catch((error) =>
          console.error("Error fetching profesionales:", error),
        );
    }
  }, [isOpen]);

  return (
    <div id="equipo">
      <button
        onClick={() => setIsOpen(true)}
        style={{ background: "none", border: "0" }}
      >
        <AiOutlineTeam /> Revisar Equipo
      </button>

      {isOpen && (
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Equipo RedMaestra</h2>
            <div className="equipo-kpi-grid">
              {equipoKpis.map((kpi) => (
                <div key={kpi.title} className="equipo-kpi-card">
                  <span>{kpi.title}</span>
                  <strong>{kpi.value}</strong>
                </div>
              ))}
            </div>
            <div className="profesional-list">
              {profesionales.length > 0 ? (
                profesionales.map((profesional) => (
                  <div key={profesional.id} className="profesional-card">
                    <img
                      src={profesional.imagen}
                      alt={profesional.nombre}
                      className="profesional-image"
                    />
                    <div className="profesional-info">
                      <h3>{profesional.nombre}</h3>
                      <span className="profesional-user">
                        <FaUser /> {profesional.user?.username || "No asignado"}
                      </span>
                      <div className="group-badges">
                        {profesional.groups?.length > 0 ? (
                          profesional.groups.map((group, index) => (
                            <span
                              key={index}
                              className="group-badge"
                              style={{ backgroundColor: group.color }}
                            >
                              {group.name}
                            </span>
                          ))
                        ) : (
                          <span className="group-badge no-group">
                            No asignado
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="profesional-contact">
                      {profesional.user?.email ? (
                        <a
                          href={`mailto:${profesional.user.email}`}
                          className="email-link"
                        >
                          <FaEnvelope />
                          {profesional.user.email}
                        </a>
                      ) : (
                        <span>
                          <FaEnvelope /> No disponible
                        </span>
                      )}
                      {profesional.celular ? (
                        <a
                          href={`tel:${profesional.celular}`}
                          className="phone-link"
                        >
                          <FaPhoneAlt />
                          {profesional.celular}
                        </a>
                      ) : (
                        <span>
                          <FaPhoneAlt /> No disponible
                        </span>
                      )}
                    </div>
                    <div className="profesional-kpis" aria-hidden="true">
                      <div className="profesional-kpi-box" />
                      <div className="profesional-kpi-box" />
                      <div className="profesional-kpi-box" />
                    </div>
                  </div>
                ))
              ) : (
                <CargandoSpinner />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EquipoModal;
